import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, CategoryScale } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, CategoryScale);

export default function PieChart({ pieData }) {
  const { ongoing, new: newJobs, shutdown } = pieData;

  const labels = ['New', 'Ongoing', 'Shutdown'];
  const backgroundColors = ['rgba(255, 165, 0, 0.6)', 'rgba(70, 130, 180, 0.6)', 'rgba(178, 34, 34, 0.6)'];
  const borderColors = ['black', 'black', 'black'];  

  const doughnutLabel ={
    id: 'doughnutLabel',
    beforeDatasetsDraw(chart, args, pluginOptions) {
      const {ctx, data} = chart;

      ctx.save();
      const xCoor = chart.getDatasetMeta(0).data[0].x;
      const yCoor = chart.getDatasetMeta(0).data[0].y;
      ctx.font = 'bold 30px sans-serif';
      ctx.fillStyle='#999999';
      ctx.textAlign='center';
      ctx.textBaseline='middle';
      ctx.fillText(`Active Jobs`, xCoor, yCoor-35)
      ctx.fillStyle='white';
      ctx.fillText(`${ongoing+newJobs}`, xCoor, yCoor)
    }
  }

  const data = {
    datasets: [
      {
        data: [newJobs, ongoing, shutdown],
        backgroundColor: backgroundColors,
        borderColor: borderColors,
        borderWidth: 1,
      },
    ],
    labels: labels,
  };

  const options = {
    plugins: {
      legend: {
        labels: {
          color: 'white',
          font: {
            family: "Montserrat",
            weight: "600",
            size: "20"
          },
        },
        position: "top"
      },
      title: {
        display: true,
        text: 'All Jobs',
        color: '#999999',
        font: {
          family: "Montserrat",
          weight: "600",
          size: "32px"
        },
        position: "top"
      },

    },
  };

  return <Doughnut data={data} options={options} plugins={[doughnutLabel]}/>;
}
